import MileageRangeTapEvent from 'lib/Tracking/Srp/SearchFilters/MileageRangeTap';
import { srpFilterInitialValues, useMileageFilter } from 'lib/hooks/useSrpFilters';
import useEvents from 'lib/hooks/useEvents';

import InputSliderBlock, {
  InputSliderBlockValue,
} from 'components/Shared/SearchFilter/InputSliderBlock';
import { useContext } from 'react';
import SrpEventContext from 'contexts/SrpEventContext';

export default function MileageInputSliderBlock(): JSX.Element {
  const logger = useEvents();
  const { sourcePage } = useContext(SrpEventContext);
  const { value, setValue } = useMileageFilter();

  function onChange(val: InputSliderBlockValue): void {
    setValue(val);
    logger.log(MileageRangeTapEvent({ sourcePage }));
  }

  return (
    <InputSliderBlock
      onChange={onChange}
      minAllowed={0}
      maxAllowed={srpFilterInitialValues.Mileage.max}
      initialMin={value.min}
      initialMax={value.max}
      minPlaceholder={'0'}
      maxPlaceholder={'300,000+'}
      pushable={0}
      step={1000}
      hasThousandSeparator={true}
      disableMinChange
      getMinSuffix={(): string => 'mi.'}
      getMaxSuffix={({ numericValue }): string | undefined =>
        numericValue && numericValue >= srpFilterInitialValues.Mileage.max ? '+ mi.' : ' mi.'
      }
    />
  );
}
